export const TID = {
  // nav
  navHome: "nav-home",
  navAbout: "nav-about",
  navTechniques: "nav-techniques",
  navGallery: "nav-gallery",
  navPress: "nav-press",
  navCommission: "nav-commission",
  navContact: "nav-contact",
  mobileMenuToggle: "mobile-menu-toggle",

  // home
  heroTagline: "hero-tagline",
  heroWatchBtn: "hero-watch-btn",
  heroCommissionBtn: "hero-commission-btn",
  credibilityStrip: "credibility-strip",
  wowMirroredVideo: "wow-mirrored-video",
  wowIndependentVideo: "wow-independent-video",
  statHundredsMillions: "stat-hundreds-millions",
  statPerVideo: "stat-per-video",
  statTiktok: "stat-tiktok",
  statHands: "stat-hands",

  // gallery
  galleryFilterAll: "gallery-filter-all",
  galleryFilterAmbi: "gallery-filter-ambidextrous",
  galleryFilterPaintings: "gallery-filter-paintings",
  galleryFilterDrawings: "gallery-filter-drawings",
  galleryFilterPortraits: "gallery-filter-portraits",
  galleryFilterAbstract: "gallery-filter-abstract",
  galleryFilterEarly: "gallery-filter-early",
  artworkCard: (id) => `artwork-card-${id}`,
  seeInHomeBtn: "see-in-home-btn",
  roomSelector: "room-selector",

  // forms
  commissionForm: "commission-form",
  commissionName: "commission-name",
  commissionEmail: "commission-email",
  commissionPhone: "commission-phone",
  commissionType: "commission-type",
  commissionMedium: "commission-medium",
  commissionSize: "commission-size",
  commissionSubjects: "commission-subjects",
  commissionNotes: "commission-notes",
  commissionRefs: "commission-refs",
  commissionSubmit: "commission-submit",

  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactSubject: "contact-subject",
  contactMessage: "contact-message",
  contactType: "contact-inquiry-type",
  contactSubmit: "contact-submit",

  newsletterInput: "newsletter-input",
  newsletterSubmit: "newsletter-submit",

  faqAccordion: "faq-accordion",
};
